import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';

const DomainSearchResultsPage = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('Tutte');
    const [selectedExtensions, setSelectedExtensions] = useState([]);
    const [categories, setCategories] = useState([]);
    const [error, setError] = useState(null);
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(500);

    const minLimit = 0;
    const maxLimit = 500;

    const navigate = useNavigate();

    useEffect(() => {
        // Se l'utente non è loggato, reindirizza alla homepage
        const token = localStorage.getItem('jwt_token');
        if (!token) {
            //navigate('/register');
            //return; // evita che il resto dell'useEffect venga eseguito
        }

        const fetchCategories = async () => {
            try {
                const authToken = localStorage.getItem('jwt_token');  //---
                if (!authToken) throw new Error('Token non trovato.');

                const host = import.meta.env.VITE_HOST;
                const port = import.meta.env.VITE_PORT;
                const response = await fetch(`${host}:${port}/api/v1/categories/get_category`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${authToken}`,
                    },
                });

                const data = await response.json();
                if (response.ok && data.status === 'OK') {
                    setCategories(data.data);
                } else {
                    setError('Nessuna categoria trovata.');
                }
            } catch (err) {
                console.error(err);
                setError('Errore durante il recupero delle categorie.');
            }
        };

        fetchCategories();

        const params = new URLSearchParams(window.location.search);
        const term = params.get('terms');
        if (term) {
            setSearchTerm(term);
            handleSearch(term);
        }
    }, []);

    const handleSearch = async (term) => {
        setLoading(true);
        const authToken = localStorage.getItem('jwt_token'); //---

        if (!authToken) {
            setError('Token non trovato.');
            setLoading(false);
            return;
        }

        const queryParams = new URLSearchParams();
        if (term) queryParams.append('name', term);
        if (selectedExtensions.length === 1) queryParams.append('extension', selectedExtensions[0].replace('.', ''));

        if (selectedCategory !== 'Tutte') {
            const category = categories.find(cat => cat.name === selectedCategory);
            if (category) queryParams.append('category_id', category.id);
        }

        if (minPrice !== null && minPrice !== undefined) queryParams.append('min_price', minPrice);
        if (maxPrice !== null && maxPrice !== undefined) queryParams.append('max_price', maxPrice);

        const host = import.meta.env.VITE_HOST;
        const port = import.meta.env.VITE_PORT;

        try {
            const response = await fetch(`${host}:${port}/api/v1/domains/search_domain?${queryParams.toString()}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${authToken}`,
                },
            });

            const data = await response.json();
            if (response.ok) {
                setResults(data);
                setError(null);
            } else {
                setResults([]);
                setError('Errore durante la ricerca.');
            }
        } catch (err) {
            console.error(err);
            setError('Errore durante la richiesta.');
        } finally {
            setLoading(false);
        }
    };

    const handleSearchChange = (e) => setSearchTerm(e.target.value);
    const handleSearchSubmit = (e) => {
        e.preventDefault();
        handleSearch(searchTerm);
    };

    const handleExtensionChange = (ext) => {
        setSelectedExtensions((prev) =>
            prev.includes(ext) ? prev.filter(e => e !== ext) : [...prev, ext]
        );
    };

    const handleMinPriceChange = (e) => {
        const value = Math.min(Number(e.target.value), maxPrice - 1);
        setMinPrice(value);
    };

    const handleMaxPriceChange = (e) => {
        const value = Math.max(Number(e.target.value), minPrice + 1);
        setMaxPrice(value);
    };

    // Funzione per navigare alla pagina di acquisto con i dati del dominio selezionato
    const handleBuyClick = (domain) => {
        console.log(domain);
        navigate('/buy-domain', { state: { domain } });
    };

      // Lista di estensioni (aggiungi altre estensioni a piacere)
  const extensions = [
    '.com', '.it', '.net', '.org', '.co', '.io', '.ai', '.us', '.ca', '.uk', '.de', '.fr', '.es', '.nl', 
    '.eu', '.in', '.tv', '.biz', '.me', '.app', '.xyz', '.co.uk', '.info', '.name', '.club', '.mobi', 
    '.org.uk', '.co.in', '.se', '.ch', '.be'
  ];

    const [isMenuOpen, setIsMenuOpen] = useState(false);  // Stato per gestire l'apertura del menu
    const [isCategoryMenuOpen, setIsCategoryMenuOpen] = useState(false);
    const [isPriceMenuOpen, setIsPriceMenuOpen] = useState(false);
    

    return (
        <section className="py-0 px-0">
            <div className="bg-[#f9f9f9] w-full py-20 flex justify-center items-center bg-[#fbfef5]" >
                <div className="max-w-[700px] w-full px-4 flex flex-col">
                <h1 className="titolo-style mb-6 text-center">
                    <span className="text-[#131904]" style={{ marginBottom: '0px', display: 'block', fontSize: '48px'}}>
                        Cerca, trova, acquista.
                    </span>
                    <span className="text-[#94c41c]" style={{ marginTop: '0px', display: 'block', fontSize: '48px'}}>
                        Ottieni il dominio perfetto!
                    </span>
                </h1>
                <div className="mt-2 flex w-full h-18 border-2 border-[#869d4a]"
                        style={{
                    borderRadius: '20px', // Applica la rotondità direttamente al div
                }}>
                    <form onSubmit={handleSearchSubmit} className="w-full flex relative">
                    <input
                        type="text"
                        name="terms"
                        id="terms"
                        placeholder="Cerca qui il tuo dominio ideale..."
                        className="flex-grow px-6 py-4 text-xl text-[#869d4a] focus:outline-none placeholder-white"
                        style={{ fontSize: '18px', color: '#869d4a' }}
                        value={searchTerm}
                        onChange={handleSearchChange}
                        autoComplete="off"
                    />
                    {/* Icona della lente di ingrandimento come pulsante di invio */}
                    <button
                        type="submit"
                        style={{
                        color: '#869d4a',
                        padding: '0px 20px',
                        borderTopLeftRadius: '0',
                        borderBottomLeftRadius: '0',
                        borderTopRightRadius: '20px',
                        borderBottomRightRadius: '20px',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'background-color 0.3s',
                        }}
                    >
                        <svg
                        style={{ width: '35px', height: '35px' }}
                        fill="none"
                        stroke="#869d4a"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <circle cx="11" cy="11" r="7" strokeLinecap="round" strokeLinejoin="round" />
                        <line x1="21" y1="21" x2="16.65" y2="16.65" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    </form>
                </div>

                <p className="mt-5 text-center text-[#94c41c] font-bold">Ricerca avanzata</p>
                
<div className="mb-6 flex">
            {/* Selettore Estensioni */}
            <div className="relative">
                <button 
                    onClick={() => setIsMenuOpen(!isMenuOpen)} 
                    className="px-6 py-3 border-2 border-[#94c41c] text-[#94c41c] bg-transparent rounded-md text-lg flex items-center gap-2"
                >
                    Estensioni
                    <span className={`transform transition-transform ${isMenuOpen ? 'rotate-180' : ''}`}>
                        ↑
                    </span>
                </button>

                {/* Menu Estensioni */}
                {isMenuOpen && (
                    <div className="absolute mt-0 w-64 h-40 overflow-y-auto bg-white border border-gray-300 rounded-md p-2">
                        <div className="grid grid-cols-4 gap-2">
                            {extensions.map((ext) => (
                                <label key={ext} className="flex items-center text-black">
                                    <input
                                        type="checkbox"
                                        checked={selectedExtensions.includes(ext)}
                                        onChange={() => handleExtensionChange(ext)}
                                        className="mr-2"
                                    />
                                    {ext}
                                </label>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* Selettore Categoria */}
            <div className="relative">
                <button 
                    onClick={() => setIsCategoryMenuOpen(!isCategoryMenuOpen)} 
                    className="px-6 py-3 border-2 border-[#94c41c] text-[#94c41c] bg-transparent rounded-md text-lg flex items-center gap-2"
                >
                    Categorie
                    <span className={`transform transition-transform ${isCategoryMenuOpen ? 'rotate-180' : ''}`}>
                        ↑
                    </span>
                </button>

                {/* Menu Categoria */}
                {isCategoryMenuOpen && (
                    <div className="absolute mt-0 w-64 h-40 overflow-y-auto bg-white border border-gray-300 rounded-md p-2">
                        <div className="grid grid-cols-1 gap-2">
                            {categories.map((category) => (
                                <label key={category.id} className="flex items-center text-black">
                                    <input
                                        type="checkbox"
                                        checked={selectedCategory.includes(category.name)}
                                        onChange={() => handleCategoryChange(category.name)}
                                        className="mr-2"
                                    />
                                    {category.name}
                                </label>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* Selettore Prezzo */}
            <div className="mb-6 w-full">
            <button
                onClick={() => setIsPriceMenuOpen(!isPriceMenuOpen)}
                className="px-6 py-3 border-2 border-[#94c41c] text-[#94c41c] bg-transparent rounded-md text-lg flex items-center"  // Aggiungi "flex" per allineare correttamente
            >
                Prezzi
                <span
                    style={{ 
                        transform: isPriceMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)'  // Applicato direttamente il trasform
                    }}
                    className="ml-2 transition-transform"
                >
                    ↑ {/* Simbolo iniziale */}
                </span>
            </button>

                {/* Sezione con input slider (quando il menu è aperto) */}
                {isPriceMenuOpen && (
                    <div className="absolute mt-2 w-64 h-40 overflow-y-auto bg-white border border-gray-300 rounded-md p-2">
                        <div>
                            <h4 className="text-lg font-semibold text-black mb-2">Prezzo Min: €{minPrice}</h4>
                            <input
                                type="range"
                                min={minLimit}
                                max={maxLimit}
                                value={minPrice}
                                onChange={handleMinPriceChange}
                                className="w-full"
                            />

                            <h4 className="text-lg font-semibold text-black mt-4 mb-2">Prezzo Max: €{maxPrice}</h4>
                            <input
                                type="range"
                                min={minLimit}
                                max={maxLimit}
                                value={maxPrice}
                                onChange={handleMaxPriceChange}
                                className="w-full"
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
                </div> 
            </div>

            <div className="container-xl mx-auto max-w-[85%] pb-10">
                
                <div className="flex flex-col lg:flex-row mt-8 lg:mt-0 gap-8">

                    <aside className="w-full lg:w-1/4 bg-white p-6 rounded-lg shadow-md">
                        <h3 className="text-2xl font-bold text-black mb-6">Filtri</h3>

                        <div className="mb-6">
                            <h4 className="text-lg font-semibold text-black mb-2">Estensioni</h4>
                            <div className="grid grid-cols-2 gap-2">
                                {['.com', '.it', '.net', '.org'].map((ext) => (
                                    <label key={ext} className="flex items-center text-black">
                                        <input
                                            type="checkbox"
                                            checked={selectedExtensions.includes(ext)}
                                            onChange={() => handleExtensionChange(ext)}
                                            className="mr-2"
                                        />
                                        {ext}
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div className="mb-6 flex gap-4">
                            <h4 className="text-lg font-semibold text-black mb-2">Categoria</h4>
                            <select
                                className="w-full p-3 border-2 border-gray-300 rounded-lg text-black"
                                value={selectedCategory}
                                onChange={(e) => setSelectedCategory(e.target.value)}
                            >
                                <option value="Tutte">Tutte</option>
                                {categories.map((cat) => (
                                    <option key={cat.id} value={cat.name}>{cat.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="mb-6">
                            <h4 className="text-lg font-semibold text-black mb-2">Prezzo min: €{minPrice}</h4>
                            <input
                                type="range"
                                min={minLimit}
                                max={maxLimit}
                                value={minPrice}
                                onChange={handleMinPriceChange}
                                className="w-full"
                            />

                            <h4 className="text-lg font-semibold text-black mt-4 mb-2">Prezzo max: €{maxPrice}</h4>
                            <input
                                type="range"
                                min={minLimit}
                                max={maxLimit}
                                value={maxPrice}
                                onChange={handleMaxPriceChange}
                                className="w-full"
                            />
                        </div>
                    </aside>

                    <div className="w-full lg:w-3/4">
                        {loading ? (
                            <div className="text-center text-gray-600">Caricamento...</div>
                        ) : (
                            <div>
                                <h3 className="text-xl font-bold text-[#94c41c] mb-4">Domini Disponibili</h3>
                                {results.length === 0 ? (
                                    <div className="text-center text-gray-600">Nessun dominio trovato.</div>
                                ) : (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                                        {results.map((result, index) => (
                                            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition duration-300">
                                                <h4 className="text-xl font-semibold text-gray-800 mb-4">
                                                    {result.name}.{result.extension}
                                                </h4>
                                                <p className="text-gray-600 mb-4">Categoria: {result.category_name}</p>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-xl font-bold text-[#94c41c]">
                                                        €{result.price}
                                                    </span>
                                                    <button
                                                        onClick={() => handleBuyClick(result)}
                                                        className="bg-[#94c41c] text-white px-4 py-2 rounded-lg hover:bg-[#75b922] transition duration-300"
                                                    >
                                                        Acquista
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DomainSearchResultsPage;
